import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <a href={CHECKOUT_URL} className={`inline-flex w-full items-center justify-center gap-2 rounded-lg border-b-4 border-navy/40 bg-electric px-4 py-3 text-center font-display text-sm font-bold uppercase tracking-wide text-white shadow-lg shadow-electric/25 transition hover:bg-[#166fbd] focus:outline-none focus:ring-4 focus:ring-electric/35 active:translate-y-0.5 active:border-b-2 sm:text-base ${className}`} data-id="element-34" data-mp="2kwle7j2sd3lv">
      <span data-id="element-35" data-mp="2yqcrn2jn17mv">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-36" data-mp="2yr4bxh7sbixu" />
    </a>;
}